import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import { createPinia } from 'pinia'
import './assets/tailwind.css'

// 🟡 Font Awesome
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'

// adăugăm toate seturile în librărie
library.add(fas, fab, far)

// 🧱 creeăm aplicația
const app = createApp(App)

app.config.globalProperties.$backendUrl = process.env.VUE_APP_API_URL
// 🌍 Configurare globală Axios
// 🌍 Configurare globală Axios
axios.defaults.baseURL = `${process.env.VUE_APP_API_URL}/api/`
axios.defaults.headers.common['Accept'] = 'application/json'
axios.defaults.headers.common['X-Api-Key'] = `Api-Key ${process.env.VUE_APP_SCHOOL_API_KEY}`
axios.defaults.withCredentials = false // JWT, deci fără cookie

// 🔒 Dacă există token salvat, îl adăugăm la toate request-urile
const token = localStorage.getItem('access')
if (token) {
  axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
}
import Swal from 'sweetalert2'

// --- Interceptor Axios pentru Refresh Token (Adăugat în main.js) ---

axios.interceptors.response.use(
    response => response,
    async error => {
        const originalRequest = error.config;
        const refreshToken = localStorage.getItem('refresh');
        
        // Verifică dacă eroarea este 401 ȘI dacă este o eroare de expirare/invaliditate token JWT
        const isTokenExpiredError = 
            error.response?.status === 401 && 
            (error.response?.data?.code === 'token_not_valid' || 
             error.response?.data?.messages?.[0]?.message?.includes('Token is expired'));

        if (isTokenExpiredError && refreshToken && !originalRequest._retry) {
            
            originalRequest._retry = true; // Marchează cererea ca încercată din nou
            
            try {
                // 1. Trimite cererea de refresh token
                const refreshResponse = await axios.post('/token/refresh/', { 
                    refresh: refreshToken 
                });

                // 2. Salvează noul Access Token
                const newAccessToken = refreshResponse.data.access;
                localStorage.setItem('access', newAccessToken);

                // 3. Actualizează header-ele pentru cererile viitoare și pentru cererea originală
                axios.defaults.headers.common['Authorization'] = `Bearer ${newAccessToken}`;
                originalRequest.headers['Authorization'] = `Bearer ${newAccessToken}`;
                
                // 4. Reîncearcă cererea originală cu noul token valid
                return axios(originalRequest);
                
            } catch (refreshError) {
                // 5. Dacă refresh-ul eșuează (refresh token expirat), forțează logout
                console.error("Refresh token a eșuat. Forțează delogarea.", refreshError);
                localStorage.clear();
                
                // Folosim Swal și router-ul pentru notificare și redirecționare
                Swal.fire({
                    icon: 'error',
                    title: 'Sesiune Expirată',
                    text: 'Sesiunea a expirat complet. Te rugăm să te autentifici din nou.',
                    confirmButtonColor: '#d33',
                });
                
                router.push('/portal/login'); 
                return Promise.reject(refreshError);
            }
        }
        
        // Propagă eroarea dacă nu este de tip refresh
        return Promise.reject(error);
    }
);
// adăugăm axios global
app.config.globalProperties.$axios = axios

// 🔗 înregistrăm FontAwesome global
app.component('font-awesome-icon', FontAwesomeIcon)
app.use(createPinia())

// 🧭 montăm routerul și aplicația
app.use(router)
app.mount('#app')
